import { render, staticRenderFns } from "./ComparativeBranchReport.vue?vue&type=template&id=70563f1a"
import script from "./ComparativeBranchReport.vue?vue&type=script&lang=js"
export * from "./ComparativeBranchReport.vue?vue&type=script&lang=js"
import style0 from "./ComparativeBranchReport.vue?vue&type=style&index=0&id=70563f1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports